import { render, staticRenderFns } from "./Myfeedbacks.vue?vue&type=template&id=24e04b2e&"
import script from "./Myfeedbacks.vue?vue&type=script&lang=js&"
export * from "./Myfeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports